import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { SecurityFeature } from '@cast/types';

import { getSecurityClustersSettingsQueryKey } from 'hooks/queries/security-insights/useSecurityClustersSettings';

type Payload = {
  clusterId: string;
  features: SecurityFeature[];
};

export const useChangeClusterSettingsMutation = (): UseMutationResult<
  unknown,
  unknown,
  Payload,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ clusterId, features }) => {
      return apiClient.securityInsights.changeClusterSettings({
        id: clusterId,
        body: {
          features,
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getSecurityClustersSettingsQueryKey(),
      });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
